const menu = {
    label: 'Interlocutores',
    icon: 'pi pi-fw pi-users',
    to: '/mapaparceiros/interlocutores',
    rules: ['MAPAPARC-PAR-00'],
};

export default menu;